import axios from "axios";
import { getBaseUrl } from "./config";
import { AcceptVapSureQuotePayload } from "../interfaces/AcceptVapSureQuotePayload";

export const createQuote = async (payload: any) => {
  const response = await axios.post(`${getBaseUrl()}/quote`, payload, {
    headers: {
      "Content-Type":
        "application/eu.aioinissaydowa.frontoffice.quote.sa.telesurestandard.v1+json",
    },
  });
  return response.data;
};

export const acceptVapSureQuote = async (
  externalId: string,
  quoteNumber: number,
  payload: AcceptVapSureQuotePayload,
) => {
  const response = await axios.post(`${getBaseUrl()}/quote/accept`, payload, {
    params: { externalId, quoteNumber },
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
